function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.2857 20H16.4286L17.5714 9.71428L6.14284 9.71428L7.2857 20ZM14.1428 6.28128V4H9.57142V6.28128L5 6.2857L5 9.71428L6.14064 8.57142L17.5714 8.57142L18.7143 9.71428V6.28128H14.1429H14.1428ZM12.9845 6.28128L10.7143 6.28128V5.14064L12.9845 5.14064V6.28128Z",
  fill: "#8A99A8"
});
const SvgDeleteBusket = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeleteBusket, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete-busket.9d1b0e7d.svg";
export { ForwardRef as ReactComponent };